/**
 * @generated SignedSource<<f615eaa770608c72f6e72726dfd46732>>
 * @relayHash a41aec4c5ac61867f896019df28bef12
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a41aec4c5ac61867f896019df28bef12

import { ConcreteRequest } from 'relay-runtime';
export type ContactChannel = "APP" | "EMAIL_AND_SMS" | "NO_CHANNEL";
export type Country = "CH" | "DE";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type useDeDuplicatePatientChangedSubscription$variables = Record<PropertyKey, never>;
export type useDeDuplicatePatientChangedSubscription$data = {
  readonly de_patientChanged: {
    readonly contactChannel: ContactChannel;
    readonly country: Country;
    readonly displayId: number;
    readonly firstName: string;
    readonly gender: Gender;
    readonly id: string;
    readonly lastName: string;
  };
};
export type useDeDuplicatePatientChangedSubscription = {
  response: useDeDuplicatePatientChangedSubscription$data;
  variables: useDeDuplicatePatientChangedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "de_Patient",
    "kind": "LinkedField",
    "name": "de_patientChanged",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "gender",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contactChannel",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "country",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeDuplicatePatientChangedSubscription",
    "selections": (v0/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useDeDuplicatePatientChangedSubscription",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "a41aec4c5ac61867f896019df28bef12",
    "metadata": {},
    "name": "useDeDuplicatePatientChangedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "27a71f14710f80b84cab9e5706300286";

export default node;
